import React from 'react';
import Button, { IButtonProps } from '@/components/Button';
import { useRegisterLimitations } from '@/modules/register/hooks/useRegisterLimitations';

export interface IRegisterButtonLinkProps extends IButtonProps {}

export const RegisterButtonLink = (props: IRegisterButtonLinkProps) => {
  const { registerLink } = useRegisterLimitations();

  return (
    <a href={registerLink}>
      <Button
        analytics={['AUTH_CREATE_ACCOUNT']}
        id="auth_submit_createAccount"
        variant="outline"
        isFullWidth
        {...props}
      >
        ایجاد حساب
      </Button>
    </a>
  );
};
